<template>
  <f7-page name="notificationsPage">
    <div id="notifications-page">
      <div class="sub-menu-wrapper">
        <NotificationsHeader />
      </div>

      <!-- <div class="sub-menu-wrapper filters-section">
        <div class="filters-container">
          <FilterButton @filter-click="openFilterPanel" />
        </div>
      </div> -->

      <div class="content-section">
        <NotificationsFeed :notifications="filteredNotifications" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import EventBus from '@/services/event-bus';
import NotificationsHeader from '@/components/Notifications/NotificationsPage/NotificationsHeader.vue';
import FilterButton from '@/components/Notifications/NotificationsPage/FilterButton.vue';
import NotificationsFeed from '@/components/Notifications/NotificationsPage/NotificationsFeed.vue';

export default {
  name: 'NotificationsPage',
  components: {
    NotificationsHeader,
    FilterButton,
    NotificationsFeed,
  },
  computed: {
    ...mapState('notifications', ['reports']),
    filteredNotifications() {
      return this.reports.filter(() => {
        // En un futuro se podrá filtrar por tipo de notificación, si es alerta o notificación, pero por ahora se muestran todas
        return true;
      });
    },
  },
  async mounted() {
    await this.loadNotifications();
    this.setCurrentRoute([
      {
        name: this.$t('notifications.title'),
        disabled: false,
        page: 'Notifications',
        active: true,
      },
    ]);
    this.setCurrentFilter('notificationsDetail');

    EventBus.$on('NotificationsDetails', async (params) => {
      this.$f7.preloader.show();
      try {
        if (params) {
          await this.getReports({ all: false, params });
        } else {
          await this.getReports({ all: true, params: null });
        }
      } finally {
        this.$f7.preloader.hide();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('NotificationsDetails');
  },
  methods: {
    ...mapActions('notifications', ['getReports', 'getReportsNoSet']),
    ...mapActions('filter', ['setCurrentFilter']),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    openFilterPanel() {
      this.$f7.panel.open('right');
    },
    async loadNotifications() {
      await this.getReports({ all: true, params: null });
    },
  },
};
</script>

<style lang="scss">
@import '@/pages/Notifications/notifications.scss';
</style>
